// extracted by mini-css-extract-plugin
module.exports = {"ratingsContainer":"az_lOc","heading":"az_mOc","grow":"az_nOc","barContainer":"az_oOc","bar":"az_pOc","--noHeight":"az_qOc","column":"az_rOc","stars":"az_sOc","percentage":"az_tOc"};